import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { ICreateCollectionSubtitleBody } from './create-collection-subtitle-request';
import type { ICreateCollectionSubtitleResponse } from './create-collection-subtitle-response';
import { createCollectionSubtitleResponseSchema } from './create-collection-subtitle-response';

export async function createCollectionSubtitleApi(
  collectionId: number,
  body: ICreateCollectionSubtitleBody,
): Promise<IValidatedResponse<ICreateCollectionSubtitleResponse>> {
  return postRequest<ICreateCollectionSubtitleResponse>({
    path: `/sys/collections/${collectionId}/subtitles`,
    body,
    schema: createCollectionSubtitleResponseSchema,
  });
}
